import {JsonResponse} from "./JsonResponse";

require('jquery');
require('./JsonResponse');

/**
 * @name JsonResponseHandler
 * @function
 * @param {JsonResponse} response The JSON response object.
 */

/**
 * @name HtmlResponseHandler
 * @function
 * @param {string} response The string response.
 */

export class AjaxRequest
{
	/** @type {string} */
	url;

	/** @type {string} */
	method;

	/** @type {any} */
	requestData;

	/** @type {string} */
	dataType;

	/** @type {JQuery.jqXHR} */
	xhr;

	/**
	 * Initialises a new ajax request.
	 * @param {string} url
	 * @param {string} method
	 * @param {string|object|FormData} data
	 * @param {string} dataType
	 */
	constructor(url, method, data, dataType)
	{
		this.url = url;
		this.method = method || 'get';
		this.requestData = data || null;
		this.dataType = dataType || 'json';
		this.xhr = null;
	}

	/**
	 * Sets the request data.
	 * @param data
	 */
	data(data)
	{
		this.requestData = data || null;
		return this;
	}

	/**
	 * Sets the method as POST.
	 */
	post()
	{
		this.method = 'post';
		return this;
	}

	/**
	 * Sets the method as POST.
	 */
	patch()
	{
		this.method = 'patch';
		return this;
	}

	/**
	 * Sets the method as POST.
	 */
	delete()
	{
		this.method = 'delete';
		return this;
	}

	/**
	 * Sets the data type to JSON.
	 * @param {JsonResponseHandler|null} handler
	 * @returns {AjaxRequest}
	 */
	json(handler)
	{
		this.dataType = 'json';
		this.execute((response) =>
		{
			if (handler)
			{
				// noinspection JSValidateTypes
				handler(JsonResponse.fromResponse(response));
			}
		});
		return this;
	}

	/**
	 * Sets the data type to JSON.
	 * @param {HtmlResponseHandler|null} handler
	 * @returns {AjaxRequest}
	 */
	expectHtml(handler)
	{
		this.dataType = 'html';
		this.execute(handler || null);
		return this;
	}

	/**
	 * Executes the request.
	 * @param {JsonResponseHandler|HtmlResponseHandler|null} handler
	 */
	execute(handler)
	{
		/** @type {JQuery.AjaxSettings} */
		let settings = {
			type: this.method,
			dataType: this.dataType,
			success: handler,
			error: handler
		};

		if (this.requestData)
		{
			if (this.requestData instanceof FormData)
			{
				settings.processData = false;
				settings.contentType = false;
			}
			settings.data = this.requestData;
		}

		this.xhr = $.ajax(this.url, settings);
		return this;
	}
}

export function ajaxGet(url, data, handler)
{
	return (new AjaxRequest(url, 'get', data, 'json')).json(handler);
}

export function ajaxPost(url, data, handler)
{
	return (new AjaxRequest(url, 'post', data, 'json')).json(handler);
}

window.App = window.App || {};
window.App.AjaxRequest = AjaxRequest;
window.ajaxGet = ajaxGet;
window.ajaxPost = ajaxPost;
